import React from 'react';
import styled from 'styled-components/macro';
import { SVGIcon } from '@yme/atoms/svg-icon';
import { colorBlackTransparent300, colorCoreGray500, colorCoreWhite1000 } from '@yme/tokens/colors';
import { elevationBottomLvl1 } from '@yme/tokens/elevations';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
import { RegularLinkLevel2 } from '@yme/tokens/typography';
import { getAdaptiveStyles } from '@yme/utils/styles';
import { CARD_ITEM_SETTINGS } from './constants';
export const CardItemStyled = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  box-sizing: border-box;
  padding: ${INDENT.none};

  background: ${colorCoreWhite1000};
  box-shadow: ${elevationBottomLvl1};

  flex: none;
  order: 0;
  flex-grow: 1;

  ${getAdaptiveStyles(CARD_ITEM_SETTINGS)}

  & * {
    box-sizing: border-box;
  }
`;
export const SVGIconDividerStyled = styled(SVGIcon) `
  g {
    rect {
      fill: ${colorBlackTransparent300};
    }
  }
`;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const SVGIconStyled = styled(({ isRightToLeft, ...rest }) => React.createElement(SVGIcon, { ...rest })) `
  ${(isRightToLeft) => (isRightToLeft ? 'margin-left: 2px;' : 'margin-right: 2px;')}
`;
export const CardBodyStyled = styled.div `
  width: 100%;
  overflow: hidden;

  height: 120px;
  padding-top: 14px;
  padding-left: ${INDENT.xxs};
  padding-right: ${INDENT.xxs};

  ${ADAPTIVE.minWidth.tablet} {
    height: 132px;
    padding-top: 18px;
    padding-left: ${INDENT.s};
    padding-right: ${INDENT.s};
  }
`;
export const CardHeaderRowStyled = styled.div `
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`;
export const CardFooterStyled = styled.div `
  display: flex;
  align-items: center;
  flex-direction: row;
  width: 100%;
  border-top: 1px solid ${colorCoreGray500};
  border-radius: 0px;

  padding-left: ${INDENT.xxs};
  padding-right: ${INDENT.xxs};

  height: 48px;
  overflow: hidden;

  ${ADAPTIVE.minWidth.tablet} {
    height: 56px;
    padding-left: ${INDENT.s};
    padding-right: ${INDENT.s};
  }
`;
export const RegularLinkLevel2Styled = styled(RegularLinkLevel2) `
  background: transparent;
  padding: 0;
  border: none;
`;
